var textareaReset = '_37j6gj0';

export { textareaReset };
//# sourceMappingURL=textarea-reset.css.js.map
